import Header from "../components/Header";
import CoursesTable from "./components/CoursesTable";

function CoursesPage() {
    let pagesLinks = [
        {
            name: "الفصول الدراسية",
            link: `/courses`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
    ];

    return (
        <div>
            <Header
                pageName="الفصول الدراسية"
                pages={pagesLinks}
                className="text-2xl"
            />
            <CoursesTable />
        </div>
    );
}

export default CoursesPage;
